"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getNextHandlePositionFromValue = function getNextStepValues(value, steps) {
  var filteredSteps = steps.filter(function (step) {
    return step.value === Number(value);
  });

  if (!filteredSteps[0]) {
    return 0;
  }

  return filteredSteps[0].pixels;
};

var _default = getNextHandlePositionFromValue;
exports["default"] = _default;